import * as Types from "../constants/Types";
import PointChangeHistory from "../models/PointChangeHistory";
const initialState = {
  pointChangeHistory: [],
  isFetching: false,
  pointChangeHistoryDetail: new PointChangeHistory(),
  isFetchingDetail: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.POINT_CHANGE_HISTORY_GET_LIST_ACTION:
    case Types.POINT_CHANGE_HISTORY_DETAIL_ACTION:
      return { ...state, isFetching: true };
    case Types.POINT_CHANGE_HISTORY_GET_LIST_SUCCESS:
      return { ...state, ...action };
    case Types.POINT_CHANGE_HISTORY_DETAIL_SUCCESS:
      return { ...state, pointChangeHistoryDetail: action.pointChangeHistory };
    default:
      return state;
  }
};
